// recovery.view — layar "atur password baru" setelah pengguna mengklik tautan pemulihan di email.
//
// Kenapa terpisah dari login: saat tautan diklik, Supabase sudah membuatkan sesi pemulihan lewat
// hash di URL. Kalau aplikasi langsung membuka dashboard, pengguna tak pernah sempat menetapkan
// password baru dan tautannya hangus — mereka terkunci lagi. Layar ini memaksa langkah itu selesai.
import { supabase } from '@core/supabase';
import { LOGO_IFICS } from '@ui/logo';

/** Tautan pemulihan Supabase datang sebagai `#access_token=…&type=recovery`. */
export function adalahTautanPemulihan(): boolean {
  const h = window.location.hash || '';
  return /type=recovery/.test(h) || /[?&]type=recovery/.test(window.location.search || '');
}

/** Bersihkan token dari bilah alamat — jangan tertinggal di riwayat/bookmark. */
function bersihkanUrl(): void {
  try { history.replaceState(null, '', window.location.pathname + window.location.search); } catch { /* abaikan */ }
}

export function renderPemulihan(root: HTMLElement, selesai: () => void): void {
  root.innerHTML = `
    <div class="login-card" style="max-width:360px;margin:12vh auto;font-family:system-ui;padding:0 16px">
      <img src="${LOGO_IFICS}" alt="iFiCs" style="height:52px;width:auto;display:block;margin-bottom:10px">
      <div style="font-size:15px;font-weight:700">🔑 Atur Password Baru</div>
      <div style="font-size:13px;color:#6b7a8a;margin:6px 0 12px">Tautan dari email sudah diverifikasi. Tetapkan password baru sekarang — minimal 6 karakter.</div>
      <label style="display:block;margin:10px 0 4px">Password baru</label>
      <input id="rc_p1" type="password" autocomplete="new-password" style="width:100%;padding:10px;border:1px solid #dbe4ec;border-radius:8px">
      <label style="display:block;margin:10px 0 4px">Ulangi password baru</label>
      <input id="rc_p2" type="password" autocomplete="new-password" style="width:100%;padding:10px;border:1px solid #dbe4ec;border-radius:8px">
      <div id="rc_err" style="color:#c0392b;font-size:13px;margin-top:8px"></div>
      <button id="rc_ok" style="width:100%;margin-top:14px;padding:12px;background:#0A2A4A;color:#fff;border:0;border-radius:8px;font-weight:600">Simpan Password</button>
    </div>`;
  const err = root.querySelector<HTMLElement>('#rc_err')!;
  const btn = root.querySelector<HTMLButtonElement>('#rc_ok')!;
  const simpan = async (): Promise<void> => {
    const p1 = root.querySelector<HTMLInputElement>('#rc_p1')!.value;
    const p2 = root.querySelector<HTMLInputElement>('#rc_p2')!.value;
    err.textContent = '';
    if (p1.trim().length < 6) { err.textContent = 'Password minimal 6 karakter.'; return; }
    if (p1 !== p2) { err.textContent = 'Kedua password tidak sama.'; return; }
    btn.disabled = true; btn.textContent = 'Menyimpan…';
    const { error } = await supabase().auth.updateUser({ password: p1.trim() });
    if (error) {
      // Tautan pemulihan hanya berlaku sekali & sebentar — sebutkan itu, jangan cuma "gagal".
      err.textContent = /expired|invalid|session/i.test(error.message)
        ? 'Tautan sudah kedaluwarsa atau terpakai. Minta tautan baru lewat "Lupa password?" di layar login.'
        : error.message;
      btn.disabled = false; btn.textContent = 'Simpan Password';
      return;
    }
    bersihkanUrl();
    await supabase().auth.signOut();   // masuk ulang dengan password baru = bukti password itu benar-benar dipakai
    selesai();
  };
  btn.addEventListener('click', () => void simpan());
  root.querySelector('#rc_p2')?.addEventListener('keydown', (e) => { if ((e as KeyboardEvent).key === 'Enter') void simpan(); });
}
